import { Stack } from '@mui/material'
import { NewRequest } from './_components/NewRequest'
import { Request } from './_components/Request'
import { IUser } from '~/@api/generated-api-types/global.types'
// import { CanceledRequest } from './_components/CanceledRequest'

interface Props {
  user: IUser | null
  reloadUser: () => void
}

export const OverviewTab = ({ user, reloadUser }: Props) => {
  return (
    <Stack className="gap-6 px-6 pt-8">
      {!user?._ownerPensionOrder && <NewRequest />}
      {user?._ownerPensionOrder && (
        <Request user={user} reloadUser={reloadUser} />
      )}
      {/* <CanceledRequest /> */}
    </Stack>
  )
}
